import * as z from 'zod';

import { productAndServiceTemplateQuerySchema } from './products-and-services-template-query-schema';

import { productAndServicesTemplateItemFormSchema } from '../products-and-services-template-item';

export const productAndServiceTemplateFormSchema = productAndServiceTemplateQuerySchema.extend({
  product_template_items: z.array(productAndServicesTemplateItemFormSchema),
});

export type ProductAndServiceTemplateFormSchema = z.infer<typeof productAndServiceTemplateFormSchema>;
